import { css, html } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { useEffect } from 'haunted'
import { isNullishOrWhitespace } from '../functions/nullish'
import { LitHauntedElement } from '../mixins/lit-haunted-element'

@customElement('ep-event-propagation-guard')
export class EPEventPropagationGuard extends LitHauntedElement {
  @property({ attribute: 'events', reflect: true })
  eventsStr: string = 'click';

  get events(): string[] {
    return this.eventsStr.split(',').map(e => e.trim()).filter(e => !isNullishOrWhitespace(e));
  }

  @state()
  boundEvents = new Set<string>();

  @property({ type: Boolean, attribute: 'debug', reflect: true })
  debug: boolean = false;

  override connectedCallback(): void {
    super.connectedCallback();
  }

  override disconnectedCallback(): void {
    super.disconnectedCallback();
  }
  
  private _handleEvent(event: Event) {
    // Stop the propagation of the event
    console.debug(`[${this.tagName}] Event propagation blocked: ${event.type} from`, event.target)
    event.preventDefault();
    event.stopPropagation();
  }

  render() {
    useEffect(() => {
      // Remove event listener
      for(let ev of this.boundEvents) {
        this.removeEventListener(ev as any, this._handleEvent.bind(this));
      }
      // Add event listener
      for(let ev of this.events) {
        this.addEventListener(ev as any, this._handleEvent.bind(this));
        this.boundEvents.add(ev);
      }
    }, [this.eventsStr])

    return html`
      <slot></slot>
    `
  }

  static styles = css`
    :host {
      display: contents;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-event-propagation-guard': EPEventPropagationGuard,
  }
}
